
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'backspaceKey': `⟵`,
'clearKey': `⎚ 지우기`,
'deleteKey': `⌦ 삭제`,
'downKey': `↓ 아래로`,
'endKey': `⤓ 끝`,
'enterKey': `입력`,
'escapeKey': `⎋ 탈출`,
'f10Key': `F10`,
'f11Key': `F11`,
'f12Key': `F12`,
'f13Key': `F13`,
'f14Key': `F14`,
'f15Key': `F15`,
'f16Key': `F16`,
'f17Key': `F17`,
'f18Key': `F18`,
'f19Key': `F19`,
'f1Key': `F1`,
'f2Key': `F2`,
'f3Key': `F3`,
'f4Key': `F4`,
'f5Key': `F5`,
'f6Key': `F6`,
'f7Key': `F7`,
'f8Key': `F8`,
'f9Key': `F9`,
'h64cd12550420f6f1': html`생성 
          <code>라이선스 
          </code>
          파일 
        `,
'homeKey': `⤒ 홈`,
'keyCommand': `⌘ 명령/승리`,
'keyControl': `제어`,
'keyOption': `⌥ 옵션/알트`,
'keyShift': `⇧ 시프트`,
'leftKey': `← 왼쪽`,
'pagedownKey': `페이지다운`,
'pageupKey': `페이지업`,
'rightKey': `→ 오른쪽`,
's00065e45db8c0441': `자세한 내용은 개발자 도구를 참조하세요.`,
's001dd78415a91fa0': `스크롤바 거터`,
's002fa7d1054ed082': `테두리 상자`,
's006f872a5b7f5279': `상로`,
's01b16a926920908b': `카자흐어`,
's01b56d233c6c5cac': `섹션 나누기`,
's01d32b35baa3b676': `작성자`,
's02106cc2ef0e7578': `새 핀...`,
's02ab1ea8e5100fc1': `선택 항목을 '양방향 재정의'로 표시합니다.`,
's0312976fe9da5951': `버튼`,
's03608a32f05eded2': `핀치 줌`,
's036d35e03be98d22': `수학 깊이`,
's037b1dc850a89273': `아래에서 대체`,
's0396202b716732ec': `선택 항목을 통과한 것으로 표시합니다.`,
's03f49e598ffb11cc': `폴란드어`,
's0448f1059fa01720': `탐색기를 저장, 공유 또는 인쇄합니다. 제목, 언어 또는 라이선스 등의 정보를 편집합니다.`,
's0458872c43beadef': `앞에 행 삽입`,
's04c939a414fdab21': `Tsonga`,
's050954cd4ae83304': `단어 간격`,
's05e9759cfd99c48f': `정당화`,
's063fa5a0a4903bf4': `옆으로, 왼쪽에서 오른쪽으로`,
's064339c229374050': `인코딩`,
's06634274f19b0572': `핀 선택`,
's06743b24499f0035': `앵커 센터`,
's07808b0ca6da8fef': `울타리 웹사이트`,
's07970793b21351fd': `루비 베이스 컨테이너`,
's079cf7850d9327f0': `글꼴`,
's07aa10850d9ddcc7': `양식`,
's07e6118e838b2e23': `탐색`,
's0816468df86e4036': `설정을 엽니다.`,
's082869038c117fe5': `포르투갈어(브라질)`,
's086e6c267ade2609': `채도`,
's08e12ade32ef8125': `세츠와나`,
's08e6bd98452e6bb9': `오디오`,
's0978fb5ba3145996': `목록 삽입(정렬되지 않음)`,
's09c3f1d21de14ae1': `선택 항목을 밑줄로 표시합니다.`,
's0a2d91c6720033e9': `텍스트 간격 다듬기`,
's0a3ddcba94027d95': `개체 맞춤`,
's0a6cb8d42cdb0c4a': `에스페란토`,
's0a799f583098cadf': `내비게이션 삽입`,
's0a7db790db1fc45c': `선택 항목을 스팬으로 표시`,
's0b1271f50a77dc73': `콘텐츠 상자`,
's0b24d08ea349b455': `삽입할 수 있는 모든 것. 처음에는 목록이나 이미지와 같은 비대화형 요소가 있고, 그 다음에는 위젯이라는 대화형 요소가 있습니다. 검색창을 클릭하면 새로운 위젯을 찾을 수 있습니다.`,
's0bdca49248ba4820': `바로 가기`,
's0befccf152b6c0a9': `메타데이터에서 오리엔트`,
's0c11e479416c8421': `표 캡션 삽입`,
's0c27336067c59611': `스크롤 패딩`,
's0c4593d81f147042': `기준선`,
's0c4b2e98d4ab7f5a': `앱 명령`,
's0c883713b83616a8': `활성 문서 저장`,
's0ca5c0460199cba1': `약어`,
's0cf10c4f40588f8d': `표 캡션`,
's0d86afa3c6a1e28b': `플렉스 방향`,
's0dad143dff0079fc': `말라얄람어`,
's0db05bd7ba6fff96': `탐색 가능한 문서입니다. 여기에서 텍스트를 작성하고 복사/붙여넣기, 편집 등을 할 수 있습니다.`,
's0dc452999c129e15': `실시간 다시 로드 활성화`,
's0de0febab8a4beaf': `이 패키지를 읽는 동안 오류가 발생했습니다.`,
's0e44968489e076a8': `중국어`,
's0e4862e87c7d53ce': `선택 항목을 따옴표로 표시합니다.`,
's0e6ea8870dbddab2': `문서 명령`,
's0ee28503778e4c0c': `마지막 기준선`,
's0ef01c03299bbb83': `장식`,
's0f17f32919661cff': `몽골어`,
's0f350bc4e538e3ea': `단어`,
's105a06836c40fcb4': `선택한 요소의 필터, 색상 및 블렌딩 설정`,
's106b274b5af798e5': `문장`,
's1082e1649793dca9': `선택 항목을 정의된 용어로 표시합니다.`,
's10f3845975a0351e': `메타데이터 편집`,
's1125d159f7e64df5': `디스플레이`,
's11326fd2590f4e5e': `기본값`,
's1155ec07a221e739': `스크롤바`,
's1173bf7a3e0b74c9': `최소(y)`,
's1177237a3e0e548c': `최소(x)`,
's1219d97b49650c05': `가시성`,
's123bea44f38abccf': `개체 삽입`,
's1245e2cb9f20197e': `정렬`,
's12946ec1b850962c': `다음에 열을 삽입합니다.`,
's1351209ef74ee729': `모든 열에 걸쳐 표시`,
's13c60cb409e8cb6f': `중앙 정렬`,
's13ebd619c8a06a6d': `그리드 자동 행`,
's13ef8ca26ca8861b': `잘라내기 요소`,
's151bc2eea7a032a4': `-변경되지 않음-`,
's153bc3c3aa39587b': `테이블 헤드`,
's156647179b21d351': `표 본문 삽입`,
's158b6ec6b1fffcb2': `휴식 후`,
's15d0c0657c1ee08c': `API 키`,
's1626a7e10a9f9dcc': `선택 항목의 글꼴 패밀리를 설정합니다.`,
's1637c7d1a30629e2': `테두리 상자`,
's1641ab440bf4daa4': `이 위젯 패키지 업데이트`,
's166bd56d19670a72': `Zoom`,
's1696c76a23c0834e': `고급: 패키지 관리자에서 0.x.x와 같은 버전의 패키지를 표시합니다.`,
's16b9446e3a70e1f4': `속성`,
's16f205466761e583': `광학 글꼴 크기 조정 없음`,
's16f2f1c2c516d307': `문서 열기`,
's1749014f3f87fa6a': `Stretch`,
's17597a8bb4810524': `라이선스`,
's17bfaaa4e7528bc7': `Bashkir`,
's17fb3f4805f4f4b9': `필드 제거`,
's181ef198cf83ec3a': `비하리`,
's1857db526dc4dcdd': `패키지 만들기`,
's18d5c44aae3dc82a': `편집 시 온라인`,
's1988d71ef8060edf': `표 행 삽입`,
's19abee1277c9bca2': `사모아`,
's19daf2f26c19543d': `개요`,
's1a1acc902e6668e0': `고급 텍스트 서식 표시`,
's1a5230a71d9285c1': `캡처`,
's1aa1cb63ad44bc6f': `열 간격`,
's1af8b67d1c85c811': `사이 공간`,
's1b4a36fce2456660': `글꼴 패밀리`,
's1c246045629b0016': `선택 항목을 삭제로 표시합니다.`,
's1c3fc313a9184670': `공개 링크`,
's1c65f5004a07dcfa': `스코틀랜드 게일어`,
's1c690963f1e2df00': `플랫폼별 보기`,
's1ca22ce85e074da5': `Pragma`,
's1d10d2058d8ca8dd': `짧은 가이드 투어를 원하시나요?`,
's1d19244f549ec535': `교육`,
's1d5c7b28e8b50d6d': `준학사 학위.`,
's1db591f5a54dbfd3': `콘텐츠 상자`,
's1dbb9f50e16c92a3': `테두리 반경`,
's1dfb744260fb3a01': `양방향 격리`,
's1e9c2c654732cc5f': `바이엘러시아어`,
's1eaccbf2d6af8ab5': `정보`,
's1efbfc3937d565bd': `배경`,
's1f2b49c1bca2035d': `카탈루냐어`,
's1f74bdf32b51a5fc': `배경 이미지`,
's1f7698c061c208c9': `열기`,
's1f8e59d0624842ff': `칸나다어`,
's1feab14d837eadb0': `과라니`,
's20deffeecf2699fb': `코르시카`,
's21d61916eb8d137d': `표 본문`,
's21d723a1dbcd89c8': `자바`,
's21f8a2eaf5a70749': `레이블 삽입`,
's2206c42e5b835e6e': `선택 항목을 약어로 표시합니다.`,
's22a2348c46a912a0': `섹션 삽입`,
's233ae776268cd44b': `비즈니스`,
's236ed7ba747099b0': `글꼴 무게`,
's2474e7fb1aec9f05': `테스트`,
's2492f5fb1b05b45e': `텍스트`,
's24949d7adbb5a098': `도구 상자`,
's252a52330d32b900': `메타데이터`,
's2540844a4bc4d9ba': `어트리뷰션이 필요하신가요?`,
's255857544a9d5ec0': `초기화`,
's255c77900f2b5e0f': `색 구성표`,
's256ab831a48c941c': `선택 영역에서 모든 텍스트 서식을 제거합니다.`,
's2591806d7b222591': `변경 사항 재설정`,
's25e1a07e454c2c11': `그리드`,
's262abbaf1d05f009': `부드러운 조명`,
's266935f2447fcd98': `왼쪽 위`,
's268ecd1cef45a9a8': `확실하신가요?`,
's2692bc028fed91f1': `캡 잠금`,
's27056379e0acfdb0': `밝게`,
's27076e66c5d483ba': `세로 정렬`,
's2712dc5641a33226': `패키지 레지스트리 계정은 개발자를 위한 것으로 하나 이상의 레지스트리를 구성할 수 있습니다.`,
's27cc88818cc46ff6': `안정적`,
's281d957112b10f12': `문서의 HTML을 직접 편집`,
's28b6246ce616a548': `테이블 열 그룹 삽입`,
's29a1c26521879b9f': `축소`,
's29acfd2778e8c377': `고급 텍스트 서식 숨기기`,
's29b24c06315e9343': `입력 삽입`,
's29eb103449472e3b': `제목 삽입(레벨 3)`,
's29ee7434494a0dfe': `제목 삽입(레벨 2)`,
's29f21c34494d614d': `제목 삽입(레벨 1)`,
's29fbfc3449557f72': `제목 삽입(레벨 6)`,
's29ff743449588131': `제목 삽입(레벨 5)`,
's2a031834495bcdb4': `제목 삽입(레벨 4)`,
's2a75c946ef4dcab7': `기타`,
's2b2ae20d26f78ac2': `블록`,
's2b8f50c64be440f7': str`선택 
          ${0}... 
        `,
's2ba5f4d8f3bd7c57': `주문`,
's2bad2d24def4aa0b': `줄 바꿈(한중일어)`,
's2ceb11be2290bb1b': `취소`,
's2ced8e8fafb499f6': `요소 삭제`,
's2d986d31f8d67357': `필드 집합 삽입`,
's2d995a37cf5e4995': `NoScript 삽입`,
's2de969afacdaa7a6': `모양`,
's2df075aface0dab8': `공유`,
's2e192b19ed15fcf6': `페이지`,
's2e39b99cf23606fa': `선택한 요소의 레이아웃 설정`,
's2e4818861000b13f': `레이아웃`,
's2e66bf8b833858f3': `Uigur`,
's2e969a451b4955d1': `마라타어`,
's2eda5288a65bca1d': `오버플로(y)`,
's2edd6688a65e21f0': `오버플로 (x)`,
's2f0bcdffc92a786b': `오른쪽 플로팅`,
's2f2044f2431a32d5': `제목`,
's2f4d4bfbc466d91f': `알바니아어`,
's2f8da2cb5f236588': `패키지 이름입니다. 범위가 지정되어야 합니다(예: \`@org/pkg\`). `,
's30cce87854901922': `프리스쿨`,
's3124653c272f054c': `열 규칙 색상`,
's314a4f7685c8e824': `항상`,
's31c06e226322f065': `고아 방지`,
's323dcde72b850272': `공개 액세스`,
's32911e52ee8ac745': `슬롯 삽입`,
's337a1e9022a8d19f': `표`,
's33c1450d2822bb0f': `그림 캡션 삽입`,
's33c18d5a4cbffa2a': `Irish`,
's33f85f24c0f5f008': `저장`,
's342b0cabfa672822': `사용자가 위젯을 쉽게 찾을 수 있도록 지원`,
's3437e0d9899e7ae1': `WebWriter 사용에 대한 원격 분석 데이터를 전송합니다.`,
's344ea8f4939cdc98': `색상`,
's34dcda3b0f9d5a98': `URL 토글`,
's34f724979a124c50': `선택한 텍스트의 배경색을 설정합니다.`,
's355b21b89ce5d9c5': `세부 정보`,
's35ae5f4e0fa2777b': `사용자 지정 정렬`,
's35aeaff1425bca9e': `WebWriter는 다음과 같은 유형의 미디어를 지원하지 않습니다. `,
's35c3125c7750681e': `블록따옴표`,
's3643189d1abbb7f4': `코드`,
's3649bacefe731bf6': `도구 상자 토글`,
's365280e16a8ea32d': `선택 항목 복사`,
's366991b9c9287765': `오른쪽`,
's36a194e38d653a26': `데이터 어노테이션`,
's36b3cefdcb897f15': `관점`,
's372fae706048ce41': `짝수-홀수`,
's377e24af9628c37e': `정렬된 목록`,
's37a8c35f6581da5f': `앵커 없음`,
's37fa3b9cd51c2dfd': `선택 항목의 글꼴 크기를 설정합니다.`,
's380d17664bb69531': `앞에 열 삽입`,
's3815184eb09f0dcf': `커서`,
's382a2aa3984474dd': `만들기`,
's38980f98cb07ceb8': `활성 문서를 사본으로 저장`,
's3914cb410fca44d4': `가져오기`,
's3a179f6db2972384': `루비 위치`,
's3a5ca02f282d247e': `공유...`,
's3ae67088bbefba98': `패키지`,
's3b0ab4b52326316f': `빛`,
's3bdad99768e11911': `탐색 가능`,
's3cb47df8290fa94c': `옵션 삽입`,
's3cf89cb47fdde7e9': `링크`,
's3d09398e555ee5f9': `고급 옵션`,
's3d249bb480032121': `목록`,
's3d3efd1e19bdcfb4': `날짜/시간 주석`,
's3d6a732c792ccb9e': `루비 어노테이션`,
's3d93f9ea0c5a13fa': `이미지`,
's3d9548e211b958ce': `중복 건너뛰기`,
's3e092e9d1ee2c5bb': `클립`,
's3e78ddc9a48a608d': `예쁘다`,
's3eb6d1e6e79ed7c4': `문서를 찾을 수 없습니다.`,
's3eca5a034978754b': `선택 항목 삭제`,
's3f06e9abb6ebcb79': `문자`,
's3f1e7a3f2b283d3b': `마진`,
's3f299e83cbf52fba': `Zhuang`,
's3f43ef2eaa1ec486': `구자라트어`,
's3f7e097a9b2e6181': `문서 삽입`,
's3fd83566dd643d10': `범례 삽입`,
's3fe72792941c18f9': `텍스트 하단`,
's3ffcdc5db5e7d0c5': `역방향`,
's40e3826b7f74a3b5': `팬(오른쪽)`,
's40f07d7859284a44': `지배적 기준선`,
's4101ada154a1b958': `가운데`,
's410c465a5993f82d': `줄 바꿈 기회`,
's41322d19c928c603': `ICT`,
's417b90913e05bc17': `미리 보기`,
's418f2020fe996832': `변경 사항 확인`,
's41c724f0698148e9': `선택 항목을 키보드 단축키로 표시`,
's41f65a763f8e44ab': `테이블 헤더 그룹`,
's42721130228841b0': `획 상자`,
's429bd646f1cf8bc6': `문법 LLM 계정을 사용하면 문법 LLM API를 사용하여 텍스트의 문법을 수정할 수 있습니다.`,
's429dd933ba95549b': `주소 입력`,
's42e470ef1d707a28': `자동 재생`,
's42ffdab1291fb3de': `다음에 행을 삽입합니다.`,
's430831017f3f0499': `기울기(y)`,
's430bd5017f42511c': `기울기(x)`,
's433ba70286202ceb': `모두 보기`,
's441b20a8a50e36b4': `마케도니아어`,
's445b8acb9206db6e': `삭제 및 취소`,
's446a924922651ea0': `텍스트 강조`,
's44cdba92713de38e': `그리드 영역`,
's45518abd911471d0': `크로아티아어`,
's456a8d744313852a': `주변 공간`,
's4634541f5056a546': `아브카즈어`,
's46d4abe6255cb9e1': `바로 가기 재지정`,
's4730c232e7209c40': `둘 다 다듬기`,
's474f0eec369d02a4': `샘플 출력`,
's47a8f6dfb38b9701': `텔루구어`,
's47e257ae643b5851': `선택 항목을 날짜/시간 주석으로 표시합니다.`,
's47ebf3a8fb3b10c1': `오리엔테이션`,
's4802bb8eb52fbdeb': `포털`,
's4802e47fe2e95134': `옵션`,
's491d2919cd6ec3d9': `색조`,
's497838412cb455f2': `텍스트 그림자`,
's4993444bfd3f3e5e': `접기`,
's49ad24935b14e3df': `케추아어`,
's49c560aecfeb8c29': `마스크`,
's49dd67aed00029ef': `수학`,
's49e763aed00877a8': `메인`,
's4a894f57eba1cf1e': `키보드 단축키`,
's4ac1ad6ecd6bd810': `기타 편집.`,
's4ad6e9d3c2365c98': `하드 라이트`,
's4b2c143acf931122': `선 높이`,
's4b58c01e2578f5e4': `범례`,
's4bbff4e008690da1': `페이지 피하기`,
's4c402ff5355fd310': `양방향 재정의`,
's4caed5b7a7e5d89b': `영어`,
's4cb38675a21b2c98': `지원되지 않는 속성 유형 '\${desc.type}'(JSON으로 처리)`,
's4cc8391f172c0cdf': `투어 종료`,
's4d528b416ac8dee2': `제목 그룹 삽입`,
's4d546f6c87128d5b': `공간 우선`,
's4dcb9315f6527f9c': `다시 로드 시 실행`,
's4e191bdb4700a6e9': `오버스크롤 (x)`,
's4e1c7fdb470386ac': `오버스크롤(y)`,
's4e2562fe3990e621': `연결 오류`,
's4e361bf8eef3759a': `단어 나누기`,
's4ea0f21fc2a338a1': `위로 이동`,
's4eace13b3ed74187': `사이드 코멘트`,
's4efee5b48a4593cb': `Loop`,
's4f26e7cb7c0a8318': `벡터 드로잉`,
's4fd2e638aabb0bb3': `WebWriter는 다양한 소스 임베딩을 지원합니다. 콘텐츠 링크를 붙여넣기만 하면 됩니다:`,
's4fda04cbc245e18b': `Alpha`,
's4ffac3fb33a2ee9b': `Thai`,
's5015a8fb33b98872': `Thin`,
's50489ffb1bde152e': `삽입`,
's5068560b8d39663d': `클릭 가능한 지도`,
's517acbf1f96324f9': `무게`,
's523eb9043213ff0d': `이탤릭체`,
's52777d434baeed9b': `진행률 표시기 삽입`,
's52af5d7ac34c2163': `테이블 행`,
's52e0bdc3ee304436': `미터 삽입`,
's531056f039febd39': `선택 항목 삽입`,
's536695196d0b6dc3': `Faeroese`,
's542fcefa0bbaed86': `도구 상자를 열거나 닫습니다(좁은 화면에서만, 그렇지 않으면 도구 상자가 항상 측면에 표시됨).`,
's5432ad3c84273229': `그림`,
's543906d1db8b2283': `편집 `,
's543c237e8c895ce8': `비슬라마`,
's545ee1f373f249cf': `캄보디아어`,
's54897f2764b0e4d0': `이 위젯 패키지 설치`,
's54cbfaf2a8da7818': `파슈토어`,
's550839f3e4e205bb': `선택 항목을 매우 중요로 표시`,
's55905c735052d295': `주제별 휴식`,
's5590dbf7e425789d': `라벨`,
's5623aa2f83b05c76': `티베트어`,
's564d1648b1ceee9f': `최신 정보`,
's565cd5ffb0158c46': `지역 피하기`,
's571a4f19e2f140c7': `팬(x)`,
's571db319e2f4208a': `팬(y)`,
's575e795c45e2d97e': `뒤로 가기`,
's5787c6d5b3b5541a': `클립 경로`,
's579c69f419b6caef': `Smooth`,
's587ac858dd80f6fa': `구독`,
's58bec0ecd4f3ccd4': `Strict`,
's59404f5593c32fdc': `글꼴 커닝`,
's5941292bb77281ab': `노르웨이 복말`,
's599dcd2472c75c19': `단락`,
's59b20e8af32606ed': `멀리`,
's5a1a0898baf20675': `데이터 주석으로 선택 항목을 표시합니다.`,
's5a356677b61a6b7e': `몰다비아어`,
's5b474b5c0ac0c7c4': `테이블 열 그룹`,
's5b517ac216f9ee62': `옆으로`,
's5b8cc9bb61ddce15': `단락 삽입`,
's5bba2ac2e53bd1fd': `키르기즈`,
's5be80ad6b8301710': `인라인 시작`,
's5c1ecf88259b79f9': `프레젠테이션`,
's5c2a1a52c0389c30': `엔지니어링`,
's5c63af7695445fcf': `텍스트 스타일`,
's5d18ca4c3111be6f': `테이블 헤드 삽입`,
's5d87c1e588f48d90': `연습`,
's5d929ff1619ac0c9': `검색`,
's5da52af9b083c29a': `모델`,
's5dc77784260a7236': `자동`,
's5e27738a2e8eb763': `로그인`,
's5e2cba97c0d971bd': `패키지 다시 로드`,
's5e53415a6d5719ad': `사회 과학`,
's5e6a7a0c30d2a270': `중복 건너뛰기(자동)`,
's5e9e8e4d21bafedc': `식품 생산`,
's5ed03bb1f3a15949': `사진`,
's5f43af3669b1e098': `출처`,
's5feaf7fd7ee567c8': `단어 끊기`,
's600fd23c9ce971e8': `활성 문서 인쇄`,
's602bbd28dae2c60f': `셀프 시작`,
's60ff598dfcf2c773': `오른쪽 아래`,
's61053f0e3ebbd272': `정상`,
's613c6ff83883c04f': `테이블 열`,
's6196153c4b0c1ea0': `설치`,
's61c017f6d5c303af': `프리시안`,
's61ded17ca3f48c82': `밑줄 오프셋`,
's61eacb19db252f5e': `URL`,
's621ad19d35ba7742': `선택 항목 복사`,
's624e31cd4f1b89d4': `부드러운 스크롤`,
's626daf42b1ab7df7': `왼쪽 정렬`,
's6280bf993915c57a': `스크롤 여백`,
's62b857f5b6693742': `Inupiak`,
's63d894b1ddb06289': `설명`,
's63dfc5b1c1c27849': `이디시어`,
's63e03c70f67ebf9c': `컨텍스트`,
's63e71d20d1eaca93': `독일어`,
's640bc7710d0143ce': `활성 문서에서 마지막으로 실행 취소한 변경 내용을 다시 실행합니다.`,
's64dc1fc7e3db45c9': `새 문서 만들기`,
's65ac276544ba33cd': `SVG 파일`,
's66765c420ee578e4': `균등한 공간 확보`,
's669b18c6d2d9c95b': `없음`,
's6747dbf4ad6063ba': `자체 종료`,
's6787497df07fa97e': `정류장 위로 스크롤 가능`,
's67c2b60a506a09e4': `보조 편집.`,
's680bd4d926cd5a84': `3D 보존`,
's6827930ef1aeaf99': `기본 URL`,
's684a16f3c711394d': `오른쪽 이상`,
's687e27f036a71b32': `격리`,
's68b87d7b61052dc3': `테이블 행`,
's68e0e3a2bab7ce3e': `피하기`,
's690da6b432987c6f': `현재 문서의 변경 내용을 자동으로 백업합니다. WebWriter를 다시 로드하면 변경 사항이 복원됩니다.`,
's69311c4e25074fb3': `고등학교`,
's697400b541fbc3cd': `아래`,
's6988ab5d47593a26': `최신 버전의 WebWriter를 사용 중입니다.`,
's69a49786a8009f43': `패키지 찾기...`,
's69b12144dbb6544d': `Laothian`,
's69d88ef4b2618980': `커버`,
's69fbbdb8ad2a084a': `어둡게`,
's6a31eff1ec4f71ad': `뒷면 숨기기(3D)`,
's6ac62e1c8c66f3bb': `컴팩트한 슈퍼스크랩.`,
's6b585ba37cdb8260': `상속`,
's6b61f8abf89586be': `히브리어`,
's6bd7a02fdf93e653': `콘텐츠 정렬`,
's6cfc66b824ea05ba': `선명한 가장자리`,
's6d02dc19e21eb49c': `Top`,
's6d1df519e235a6cf': `Twi`,
's6d60d595cb5070da': `베트남어`,
's6d8b3b8047ed378d': `믹스 블렌드 모드`,
's6d8c02aee480af7a': `메뉴`,
's6dadeaaee49d6d18': `메타`,
's6dfb502188a8c7c2': `스타일 삽입`,
's6e288a119281f4c2': `텍스트 렌더링`,
's6e4c20c6debcd5ca': `사용자 정의 정의`,
's6f84199e62584905': `미리 서식이 지정된 텍스트`,
's6fb3053e7244d326': `기타 필드`,
's70178e04a3b691b6': `설정 열기`,
's7031ca562378bde6': `기하학적 정밀도`,
's7060970b5ed20a58': `상호 작용`,
's7136449045eff28c': `타밀어`,
's71940c32987f675f': `웹라이터 클라우드`,
's71a0549fd71219c9': `불안정한 패키지 표시`,
's71dec51005acc1e4': `행 밀도`,
's72f2a02e2a5a4ee3': `미디어`,
's730182ad28374cda': `개체`,
's731678e227a20559': `이 장치`,
's736904f276fbd441': `자연 과학`,
's739544d0c858c633': str`또는 
          ${0} 여기 
        `,
's73cb20c838e761e1': `컷 선택`,
's7417792bbe720149': `다시 실행`,
's741fae02b3dd24f3': `픽셀화`,
's743f778233e42a3f': `사이드바 삽입`,
's744d993d03f29851': `화면`,
's748c0074eff45884': `조작`,
's74aa0039a87141e2': `줄임표`,
's74b9781bacfcc87c': `펀자브어`,
's74cd20a7aece9b91': `채우기 상자`,
's75109f5307578a61': `웹라이터에 오신 것을 환영합니다.`,
's75a27f43413e02c5': `프랑스어`,
's75d83fc3f0cfab40': `헤더`,
's762e5704cc84089d': `선택한 요소의 다른 스타일 옵션 설정`,
's77318393dfdb0775': `행 제거`,
's77e594ddcc10c774': `상업적 사용이 허용되나요?`,
's782eac2b3e80323d': `선택 항목을 강조 표시`,
's782f286a79cca35d': `상대`,
's78673a3539cb1915': `왼쪽 상단`,
's78789724e789221c': `크기`,
's789ff24c8f03f1a4': `문자 간격`,
's7995733bf97c01cc': `세르보-크로아티아어`,
's7a99528e7b64635a': `Occitan`,
's7aaf0c06e69600f1': `다음 오류 `,
's7ae49e142487766c': `커뮤니티 액세스`,
's7af555180b30a947': `개발자 도구 열기`,
's7b4ba250601b8667': `템플릿 삽입`,
's7b560d8693ed8f42': `업라이트`,
's7b9994904c4f5b54': `타지크어`,
's7bdf0fd5b014d36c': `강력한 중요성`,
's7beb1e77e82363eb': `활성 문서의 마지막 변경 내용 실행 취소`,
's7c61118554a0ec36': `최대 (x)`,
's7c95876637f6a9d7': `필터`,
's7cb4e55c59663b1c': `회사`,
's7cfe12cd14df9950': `로그아웃`,
's7d27db3c9639c6dd': `대체`,
's7d8103f6f06f83d6': `패딩`,
's7d864465dddbb50d': `크기 조정 허용`,
's7de0e28d6c309a4e': `터치 동작 허용`,
's7dea785045c3cc74': `새 키 조합을 누릅니다...`,
's7e0b179d4d1414eb': `링크 입력`,
's7e6570f2f1ae320f': `서체 합성`,
's7ecb1f29332293e5': `정렬 기준선`,
's7ed13ccddb1bf3c3': `오버레이`,
's7edbe0b213199995': `학사`,
's7ede1c55e35ce9d6': `시뮬레이션`,
's7f09197a4814079b': `선택한 요소에 대한 상호 작용 옵션 설정`,
's7f326a142e856656': `스타일`,
's7fcb35d23be1e643': `필드 세트`,
's80570196a9ce6d11': `원격 분석 사용`,
's806f84eb0ace116e': `선택한 내용을 확인하고 변경합니다. 복사, 잘라내기, 붙여넣기, 고정 또는 레이아웃 변경을 수행합니다. 텍스트 서식 등 선택 항목에 따라 다양한 옵션을 제공합니다.`,
's80a42b81c52d4d8f': `캐럿 색상`,
's80b71fc6f43c5ce1': `Loose`,
's812cbda653daaeba': `이 기능은 아직 구현되지 않았습니다.`,
's81c3d8809658b951': `카슈미르`,
's81cf65c5a46dea08': `키냐르완다`,
's81ecf2d4386b8e84': `계속하기`,
's8247d32213e35f24': `메인`,
's82665b2ffabc9c0a': `웹사이트`,
's828b1ecea8715884': `팬(왼쪽)`,
's833bd0422a7ef95d': `탭 크기`,
's83420ad7b6a14db5': `개발 도구 토글`,
's83c15613b6f6f3c8': `온라인 전용`,
's83cd32b685ccc9b7': `컨트롤`,
's83f26d02dd7aa681': `가시성`,
's840fa49e8989c028': `위치/모양`,
's844a76d1843ceb3c': `기본값으로 재설정`,
's84e4e8ae645b82ac': `오른쪽 상단(y)`,
's84e9c7f8785ca60b': `양식 삽입`,
's8517ae4da104b004': `테이블 열 그룹`,
's85186a61e0d55bac': `비디오`,
's851a7deea5984646': `크리에이티브 커먼즈 OER 라이선스?`,
's85f9aa6d3ea0e421': `표 바닥글 그룹`,
's864b0e6270e97246': `선택 항목을 사이드 댓글로 표시합니다.`,
's8670e5ad3bf0dcf8': `다른 이름으로 저장`,
's8688d74dd3716d6e': `명령에 대한 키보드 단축키`,
's86ca34c5287a2f38': `Wolof`,
's86f820d8007d0de4': `모양 여백`,
's87cefc710b3567fb': `포함`,
's88676f992b2965db': `셀 콘텐츠 늘리기`,
's886897f2fd4edb99': `숨겨진`,
's886c5db2a5579873': `개념`,
's888c71e8fcb916d3': `자동 저장`,
's88a62d29529948fb': `표 삽입`,
's89950d86c8004d4b': `중복 항목 건너뛰기`,
's89bca7498f20e041': `배경 클립`,
's8a28bad9290d4761': `Oromo`,
's8a29cb39a42f83f3': `전에 휴식`,
's8a4ff2bd9c13498c': `기록`,
's8a6585c48ea104e9': `빈 셀 숨기기`,
's8a9eb438abac7c6a': `레이블`,
's8b0432eecbd8b034': `업데이트`,
's8b7580c35e2aef87': `왼쪽 상단(y)`,
's8bc4affa761aa8a2': `이미지 삽입`,
's8c7f51cb067644c7': `데이터 목록`,
's8d342ecaa9e75b9b': `관계`,
's8d797888455f4147': `공백 나누기`,
's8d83386457e91813': `변경 사항을 실행 취소/다시 실행하거나 학습자의 관점에서 미리 보기를 할 수 있습니다.`,
's8d8643013a7754d1': `텍스트 정렬`,
's8df30fe2a50d3479': `줄 바꿈 기회 삽입`,
's8e715248c3a78446': `선택 항목 잘라내기`,
's8f29e48d6b9a1aa8': `표 머리글 행 삽입`,
's8f4be9f086eb530f': `실행 취소`,
's8f533296a536965e': `다른 이름으로 저장...`,
's8fad58c831ecf017': `루비 텍스트 컨테이너`,
's8ffe7abcbed8eb43': `세로, 왼쪽에서 오른쪽`,
's90105521fcc40453': `WebWriter 클라우드 계정을 사용하면 온라인으로 문서를 저장하고 학생들과 공유할 수 있습니다. 여기에서 계정을 추가하면 문서를 저장, 로드, 공유
          및 열 수 있는 위치로 사용할 수 있습니다.`,
's9095f01a80a91594': `Super`,
's90f0fbc12e1e2b2f': `글꼴 팔레트`,
's90f7c1cf501ea0a7': `색상 닷지`,
's91093e0b087911ba': `강조 위치`,
's919e1724f589c9b1': `슬롯`,
's91c5ed7769d00b65': `임베드 삽입`,
's9219acd5bef6269e': `왼쪽 아래`,
's92548405912d46bf': `스크롤 스냅 정렬(Y)`,
's9258280591309342': `스크롤 스냅 정렬(X)`,
's927d796559f49439': `배경 출처`,
's92b177e579ef7b97': `강조`,
's92f846b9be2e8e8d': `선택 항목을 이탤릭체로 표시`,
's93566b84230af4f5': `사진 삽입`,
's936aa0b239679585': `주제 나누기 삽입(일반적으로 가로줄로 표시됨)`,
's9370dc6afa716b57': `테두리`,
's93f083e654a45715': `브르타뉴어`,
's94653c76b2d86a04': `정의된 기간`,
's9485af2e7cd9418f': `초등학교`,
's94d2eee44b292567': `고급 옵션 토글`,
's94d61907ee22a8c1': `한국어`,
's94eb1effbbb6498b': `오버플로`,
's951aa3a6439f1271': `목록 마커`,
's9565553d163fc92a': `스크립트`,
's957787fc6b7ea5c0': `팬 (위)`,
's95d56e58f816d211': `네덜란드어`,
's95d8e41a64635c7c': `공백`,
's95de7e1eff6c053e': `가로, 위에서 아래로`,
's960d3a90ac199368': `라예토-루마니아어`,
's96532132a29dd542': `오디오 삽입`,
's96a045dcade75ad0': `열 밀도`,
's9781a5bb3fcb26a3': `먼저 회사를 선택하세요.`,
's978522fbc9577a7e': `Somali`,
's97881699a2b21d5b': `행 간격`,
's97aa76056a81bd36': `메트릭`,
's986facb3ecc9602c': `옆으로, 오른쪽에서 왼쪽으로`,
's987abd19fac8cf55': `Sub`,
's9896529e5cb20558': `외부 파일`,
's98977a87d1b93941': `정보, 스타일 및 스크립트 재설정`,
's990d0e0fa2ab00b5': `갈리시아어`,
's99229574e5692f19': `그린란드어`,
's99a990f3841ad283': `파일 `,
's99b38e000175cc84': `취소선`,
's99f110d27e30b289': `제목`,
's9ab10fbf4c7a7322': `밑줄 위치`,
's9abadcc828884d7b': `텍스트 영역`,
's9b7cd8860c8fc922': str`
          ${0}
          를 덮어씁니다. 확실하신가요? 
        `,
's9c11f2d9335d8bd1': `Oriya`,
's9c356016f81585f6': `배경색`,
's9ca757effd747da9': `우르두어`,
's9caf10388ab3562f': `테이블 열`,
's9cf68f87b8e6122f': `아제르바이잔`,
's9d167ef77aed79b6': `레이어`,
's9d2d00982edafabb': `터키어`,
's9d430adc5be110e9': `행 반전`,
's9d54829be67943d3': `인터랭귀지`,
's9d54869be6794a9f': `인터링구아`,
's9d668a34af4128ff': `삭제`,
's9df571714a1efb44': `이 탐색기의 자동 저장 버전을 사용할 수 있습니다. 로드하시겠습니까?`,
's9e28faa598332e2b': `동영상 삽입`,
's9e3dbb678150edd4': `글꼴 패밀리 설정`,
's9e40e59654c8ad67': `칼럼`,
's9e85800d3700e31c': `트랙`,
's9e8d3665edde89a6': `나우루`,
's9eefe6e57e4e1661': `글꼴 변형`,
's9f1ecdb3061d9cbc': `공간 보존`,
's9faf26107ed49fb9': `표 셀 삽입`,
's9fbe26cfd7845469': `하우사어`,
's9fc686f7bbd941e2': `전환`,
's9ff3121d30f88d52': `보통`,
's9ffe1bbe64712bf1': `캔버스`,
'sa00df4e39c72d3b4': str`
          ${0} 는 지원되지 않습니다. 
        `,
'sa013e119fec906fb': `행`,
'sa01e7bf33563ef72': `배경 첨부`,
'sa126cf8c627cec1e': `이미지 렌더링`,
'sa13f72278add7513': `오른쪽 아래`,
'sa1647e3b36ec08d7': `똑바로 결합`,
'sa172190ea21f9b1c': `설정에 액세스하여 탐색기를 열거나 새 탐색기를 만듭니다.`,
'sa1c6c459b9b5115c': `절대`,
'sa2cba871f6cdd99f': `아삼어`,
'sa2eff4dad1c119f1': `그리드 템플릿`,
'sa30c12014e955946': `러시아어`,
'sa30f1981fd1cd441': `글꼴 크기`,
'sa311a24c1471a974': `문서`,
'sa352d168b262aa06': `바닥글 삽입`,
'sa37fee6a52d18063': `문서 삭제`,
'sa39c7ac1d37f3bce': `선택 항목을 '양방향 격리'로 표시합니다.`,
'sa3b4c01623211544': `Force`,
'sa40fd43756fa8913': `페르시아어`,
'sa417644bef21a9aa': `이름 없는 테마`,
'sa43800e28be1bdbc': `장식 색상`,
'sa477cb1825dceb3b': `수단어`,
'sa492a51a707930fa': `블록 따옴표 삽입`,
'sa4e5b39489ecf31a': `Xhosa`,
'sa4f137f8619093a5': `하단 캡션`,
'sa50d3c35533f1d99': `모든 필드`,
'sa53c5cb03a8fda50': `선택 항목을 팔레트에 스니펫으로 고정합니다.`,
'sa557ae6bee9148a6': `진행 상황`,
'sa589e1df65dde0ec': `선택한 요소의 크기, 패딩 및 여백을 설정합니다.`,
'sa5c371b4bb75e590': `왼쪽`,
'sa5c80e623459ffe4': `헤더 삽입`,
'sa5df1bcdba46c3fb': `그림 캡션`,
'sa602e3fd3f2d98fd': `애니메이션`,
'sa644d580d8a11e60': `루비 정렬`,
'sa645d315510dc09e': `디스크에서 경로 선택`,
'sa65d4ad99f1d8c06': `텍스트 배경 설정`,
'sa6607436f60ccc1a': `에스토니아어`,
'sa6f8d27bca557059': `메타/링크/스타일 요소를 이 요소로 위/아래로 이동합니다.`,
'sa757645ad842da97': `휴식 시간 보존`,
'sa75b95980cd80e78': `편집기`,
'sa7698b3d20a6d1ec': `스크롤`,
'sa778acc33947c7b8': `투어 완료`,
'sa78a67272a4a6f95': `수학 공식`,
'sa79167651dce1e80': `대체 텍스트`,
'sa7af797a46c7d09a': `표 바닥글`,
'sa7dbe35b758c138d': `캔버스 삽입`,
'sa7dc6b8ef3f595dc': `소스 삽입`,
'sa8279f8211b3950d': `휴식 및 공백 보존`,
'sa8b55cab62e439b5': `열 제거`,
'sa8bbe0197d31b423': `간단한 설명`,
'sa9ff3b762365abe6': `변형 원점(z)`,
'saa02e3762368ff35': `변형 원점(y)`,
'saa065776236bfa28': `변환 원점(X)`,
'saa33768e03c45fc8': `파일 크기`,
'saaad98061a20ac39': `수학 공식 삽입`,
'saab875d8cfcfe712': `테마`,
'saad4380b9cc6cefd': `대체 오버`,
'saaec15c97a9e4245': `열 반전`,
'sab0c57df694a0a09': `트림 시작`,
'sab4d9283896d9422': `스냅 해상도 픽셀`,
'sab55faae8e165407': `틈새와 같은 패딩&lt;br&gt;`,
'sab5e7d2a069a2951': `직업 인증.`,
'sab726d2db7e6b93d': `키룬디`,
'sac687b8649989de8': `오른쪽 정렬`,
'sac895c732f350ac5': `Dark`,
'saced41ddda8b2354': `유연성 기준`,
'sad190f86451081c0': `네팔어`,
'sad6be321164d08c8': `간결한 수학`,
'sadd352cc7f6f2307': `옆으로`,
'sae098810f946ca7c': `타갈로그어`,
'sae185e6af80ec81e': `스웨덴어`,
'sae1c7f13b7c0c47f': `시작`,
'sae76e25497dcee58': `Recto`,
'sae9c790b88be7eb9': `Maori`,
'sae9d739068eee2c5': `타타르`,
'saf312eaeec77a802': `설명 목록 삽입(용어집, 용어 목록)`,
'saf3da7c95cb17260': `선택 항목을 위 첨자로 표시합니다.`,
'saf440a0a592f2835': `다음으로 업데이트`,
'saf9e5134ba1a7d30': `스크롤 스냅`,
'safc6f203342d09e2': `활성 문서의 미리 보기를 토글합니다.`,
'sb0a7e3adf4a125ee': `오른쪽 상단`,
'sb0a974028c99ca6d': `적응을 허용하시나요?`,
'sb0d4f0f7993cf085': `글꼴 크기 설정`,
'sb0f3327210fe18fc': `열`,
'sb0f93c1c60c0249a': `루비 베이스`,
'sb1494c08c8c720d1': `텍스트 색상 설정`,
'sb19611adbc88f711': `고급: 소스 편집 명령 표시(예: 문서의 HTML 표시 또는 사용자 지정 스타일 및 스크립트 추가).`,
'sb206d700d26b14ff': `밑줄`,
'sb233557012dcb328': `아래로 이동`,
'sb26035b596566abf': `Unnamed`,
'sb2cda80610c8d6ea': `모두 공백`,
'sb2dc787b0983ebc6': `리투아니아어`,
'sb31cdff08b1c5a50': `신디`,
'sb38d497d992ab4a4': `센터`,
'sb3ba3276ae93627c': `미리 서식이 지정된 텍스트 블록 삽입`,
'sb430f5b4824de0d3': `레이아웃 선택`,
'sb43db07b24da018a': `암하라어`,
'sb45f9fb4dba6e71a': `Unset`,
'sb4e003a459464d85': `쿠르드어`,
'sb4f0310e6787d098': `우즈벡`,
'sb4f1dffbb6be6302': `지우기`,
'sb51270e19988f9bd': `지역`,
'sb59d621e3c93cc27': `공유 셀 테두리`,
'sb5e9e1776242b028': `상호 작용`,
'sb60bc1250aad44c1': `Span`,
'sb60dd9d23d31ee66': `박사 학위`,
'sb6103872073d369e': `세부 정보 삽입`,
'sb616811735bfbafd': `테이블 셀`,
'sb628960829e223bb': `모든 중복 항목 건너뛰기`,
'sb6434faf698b02a2': `Shona`,
'sb657bfe93338dc8b': `볼라푹`,
'sb66beca1e766dcb3': `적용 및 가져오기`,
'sb66e2181a7b5738a': `원격 측정을 사용하도록 설정하면 다음과 같이 데이터를 수집하고 보관할 수 있습니다.`,
'sb67e0e7c0869f982': `차이점`,
'sb68e83cda6c85af8': `테이블 헤더`,
'sb6b268120592dc53': `힌디어`,
'sb6ca0a8bb3caae69': `장식 두께`,
'sb70c17f7899f9b01': `라틴어`,
'sb71941f552f3504d': `특수 값 설정`,
'sb740eab4afd5a710': `그리드 자동 흐름`,
'sb741b6e0ca589122': `레이어 되돌리기`,
'sb7c77d0415de05cf': `테스트 실행`,
'sb7fb7568f6883ab8': `활성 문서 공유`,
'sb85774dc5d18ff0f': `확인`,
'sb85b1e36579852a6': `잘못된 이메일 또는 비밀번호`,
'sb884fa76bfc55429': `아랍어`,
'sb8a3d4df7d1c5e6b': `잔액`,
'sb8f610a0e8df91fc': `광도`,
'sb8f855b49234b81b': `신청하기`,
'sb905da066c10182c': `더 어둡게`,
'sb940ade1bd81be7e': `왼쪽 아래`,
'sb9e9a7dd45966756': `선택 항목을 굵게 표시합니다.`,
'sba509fd8ed61d1d5': `저장되지 않은 파일`,
'sba64d8954d027206': `불투명도`,
'sba88d90cd6c751b3': `열 규칙`,
'sbaf0a7c417e388af': `건강`,
'sbb15d427ee1aa676': `티그리니아`,
'sbb34f2e3aa40af4e': `통가`,
'sbb55f9f2d69fd327': `배경 필터`,
'sbb85a407d730e13d': `검색 삽입`,
'sbb86c6c96f598bb8': `혼합`,
'sbba0156f795d8c07': `선택 항목 편집`,
'sbba865d4b437944f': `속성`,
'sbbe639e3a3ed95d1': `NoScript`,
'sbc5bb5bb74d141b9': `제거`,
'sbc5f2a81604baf9b': `제목 6`,
'sbc5f2b81604bb14e': `제목 5`,
'sbc5f2c81604bb301': `제목 4`,
'sbc5f2d81604bb4b4': `제목 3`,
'sbc5f2e81604bb667': `제목 2`,
'sbc6953a36ced943f': `개인정보 보호정책`,
'sbd181cd54b8402a4': `선택 항목 편집`,
'sbd35ee879d9cf770': `루비 텍스트`,
'sbd40f40cbadd38d5': `이 위젯 패키지 제거`,
'sbd72dc858de95ce8': `버마어`,
'sbe3c60c65f129daa': `인문학`,
'sbe4a7c8f231739b3': `또는 파일 붙여넣기/드롭/픽업`,
'sbe90de083557ef3e': `스와힐리어`,
'sbefb6064cba01844': `줄 바꿈 삽입`,
'sbf00e1ee999ea94e': `스크립트 삽입`,
'sbf519920c2017d67': `교수형`,
'sbfa01f189a68d3e9': `유연하게 성장`,
'sbff54e740c4086eb': `알 수 없는 패키지 표시`,
'sbfff51feacf30196': `산스크리트어`,
'sc0ceaa9843510f67': `투르크멘어`,
'sc1611c0558728a2a': `위치`,
'sc1a155cc25899250': `테이블 행 그룹`,
'sc1aa1f6051b7102a': `루마니아어`,
'sc1edebeaef92b7bd': `고정 테이블 레이아웃`,
'sc1fff4f356dfb2fb': `변환`,
'sc24bda3c061fddf8': `클릭 가능한 영역`,
'sc252a4e091763606': `표 바닥글 삽입`,
'sc2536e077514accc': `스크롤`,
'sc275dd00036d16cb': `따옴표 문자`,
'sc28864200d2a3799': `QR 코드를 이미지로 복사`,
'sc2a24a9dd41a9503': `장식 라인`,
'sc2b734cca2fa643b': `팬(아래로)`,
'sc2e2a0dbf03723b7': `고급: 패키지 관리자에서 알 수 없는 출처의 패키지 표시(경고: 안전하지 않을 수 있음)`,
'sc3998b77d72c2932': `웹사이트 삽입(인라인 프레임으로)`,
'sc3ac225273c8316b': `일반`,
'sc3cfee84dbbf36ae': `로컬 파일`,
'sc3f09a9b6fa4fbed': `내부`,
'sc43767deea72e9f3': `설명 목록`,
'sc462bbdd36bcba6b': `참조 상자`,
'sc4ee3e4ee994dafd': `우크라이나어`,
'sc50d09edf9325339': `대화 상자`,
'sc52b67794c06a0d3': `원근 원점(Y)`,
'sc52e8b794c0913d6': `원근 원점(X)`,
'sc53de149fcaad713': `캐릭터 간`,
'sc546f489f9c0cced': `활성 문서의 테스트 모드를 전환합니다.`,
'sc5bcf50d1b578d9f': `글꼴 기능 설정`,
'sc5cb39478b9b7625': `선택 항목을 아래 첨자로 표시합니다.`,
'sc6415b50ff928294': `목록 항목`,
'sc650ff15b20fe9d3': `회전(z)`,
'sc6578b15b2154365': `회전(X)`,
'sc65aff15b2183e58': `회전(y)`,
'sc6da0f4a7e4d710e': `글꼴 언어 재정의`,
'sc74e3567875ce255': `위젯의 태그와 NPM 패키지의 이름 모두`,
'sc7eb080b96e244df': `말레이어`,
'sc8ac7ef92b95df3f': `이동 (x)`,
'sc8af536e2084ade0': `팔레트`,
'sc8b022f92b992bc2': `이동(y)`,
'sc8b39af92b9c2d81': `이동(z)`,
'sc8d2c7f6c33a2b32': `선택한 요소의 텍스트 스타일(정렬, 들여쓰기, 간격 등)을 설정합니다.`,
'sc8fa0e3de389ef1c': `글꼴 크기 조정`,
'sc9474bf7a0668d73': `요약`,
'sc94e314312a8900c': `체코어`,
'sc980855a000b76ea': `하단`,
'sc98b103772de63f4': `핀란드어`,
'sca7cfe2bef51b2a5': `루트`,
'sca7fed2bef53cb99': `역할`,
'scabe6ecee5e01fd2': `Maltese`,
'scace301a88231cce': `퍼가기`,
'scbc55f622ec078c1': `보기 상자`,
'scbe537fc38ff4c13': `그리드 자동 열`,
'scc1db59d292cbc4c': `섹션`,
'scc56b218a2689c42': `아르메니아어`,
'scc5ba32e0de06744': `세소토`,
'scd15088c39fe9edf': `패딩 박스`,
'scd9cedeb5ece3adb': `하이픈`,
'scdf536b65be39ec5': ` 생성/가져오기`,
'sce8a4e3f7c98482d': `Siswati`,
'scec2be75ee985f6c': `표의 문자`,
'sceecdd0bb404bc17': `옵션 그룹 삽입`,
'scf00d48fd5953a03': `그리스어`,
'scf932840a69dbb7c': `포르투갈어`,
'scf932a8577057752': `푸터`,
'scf95dcb12a950a5c': `아이마라`,
'scfcb70f2a15eaf14': `오른쪽 하단`,
'sd01178c54f648118': `잔액 열`,
'sd03bff50f87f82d4': `하이픈 문자`,
'sd05a155fe09c2866': `온라인 사용 시`,
'sd0864ea6cb6ef22e': `커뮤니티`,
'sd10fdbe6caf9a998': `줄 바꿈`,
'sd121d3b959b7888d': `속도 최적화`,
'sd1a78e667a1a139f': `선택 항목을 삽입으로 표시`,
'sd1cffad290ea5b3b': `모두 유지`,
'sd1f10284eeb17b25': `피지`,
'sd1f44f1a8bc20e67': `이메일`,
'sd1f81984eeb7c0e8': `채우기`,
'sd29dc07235eea0f5': `견적`,
'sd2addf69477cd4b4': `패키지 가져오기`,
'sd2ed26defc646d47': `배경 필터`,
'sd2ef82b8ea877c6d': `아프리칸스어`,
'sd319aae1401f1e19': `수정됨`,
'sd3a288c1094b8a63': `열 규칙 너비`,
'sd3c65ef5c380c046': `삽입`,
'sd3dcb76f7b28adb8': `라트비아어`,
'sd3eca1e0f4209f6e': `모두 다듬기`,
'sd3f402df8619ddcd': `회원님에 대한 이 정보는 새 문서에 자동으로 추가됩니다. 메타데이터 편집기에서 각 문서에 대해 이 정보를 변경할 수 있습니다.`,
'sd4368b12645d3c0f': `포털 삽입`,
'sd452cebf4a0313d1': `소스 편집 명령 표시`,
'sd48cc52117f4d68b': `이탈리아어`,
'sd52660ee947ca58b': `표 열 삽입`,
'sd588d17a1b25c220': `텍스트 오버플로`,
'sd5be6f6d85fc0c9b': `Zulu`,
'sd5bf67958b08b4cf': `고등학생.`,
'sd5cf95145e4d89ca': `이 스니펫 고정 해제`,
'sd5fd9d11a92f5b1d': `왼쪽 하단(y)`,
'sd60c9bbc51375635': `버튼 삽입`,
'sd66c4767fa3dde28': `강조 색상`,
'sd679c8b1bf8cc8a5': `작은 대문자`,
'sd7086c4425c53c80': `글꼴 패밀리`,
'sd837f42ac7cbfb58': `모양(외부)`,
'sd88076d2994ee0fb': `제외`,
'sd89a2e529b31ef43': `되돌리기`,
'sd8a345e95668b73b': `세로, 오른쪽에서 왼쪽으로`,
'sd8ce9e57270b030d': `글꼴 늘이기`,
'sd8ecf227c7c49331': `수학`,
'sd8f923198e0c5c6a': `종료`,
'sd9c21e5f60d6bdd8': `덴마크어`,
'sd9ff8e2612e63d50': `테두리 상자 크기 조정`,
'sda2d76b976502a8d': `열기...`,
'sda344aacb837387e': `컨테이너 내 위치`,
'sda5b6fa8b771f996': `왼쪽 플로트`,
'sda9254d1f1228e1a': `헝가리어`,
'sdb1595f5c742dfbb': `입력`,
'sdb711380a28fec75': `목록 삽입(정렬됨)`,
'sdb73788b3c975f16': `자동`,
'sdbee7e0523a23a42': `오른쪽 하단(y)`,
'sdc48456f9a27ae02': `생성기`,
'sdc70d81cf6c28533': `그루지야어`,
'sdd1ff479d04ac140': `공개`,
'sdd2fc8919a9c3111': `배경 블렌드 모드`,
'sdd35b688281b6dea': `일본어`,
'sddc49047f66a64ab': `설명이 제공되지 않았습니다.`,
'sdef34fe08bb28b09': `중국어(간체)`,
'sdf62e305e1594805': `루비 주석으로 선택 항목을 표시합니다.`,
'sdf946172dfa0328f': `위 첨자`,
'sdf9bc5d9b7f3e3de': `정렬`,
'se036b53f145441cd': `혼합 콘텐츠`,
'se06f459fccdc3ce9': `마지막 텍스트 줄 정렬`,
'se0a782a8be8e018b': `Norwegian`,
'se0cda6b80a1bb50f': `슬로바키아어`,
'se0f67eae944f8f94': `음소거`,
'se1312d6528f9a259': `Yoruba`,
'se16c5e66886fbc59': `기사`,
'se1f5bb0386c88f96': `선택한 텍스트의 색상을 설정합니다.`,
'se219da7b1e955c65': `서식 지우기`,
'se25e4f2cb77b8be8': `WebWriter 인터페이스 및 새 문서용 언어`,
'se2796c5824ec8916': `콘텐츠 가시성`,
'se308836a594808b6': `Singhalese`,
'se36c5b1baf5e0660': `어디서나`,
'se39c065efa467782': `바스크어`,
'se3b4c857f91f80d7': `키보드 단축키`,
'se47baf2fd16b9d2b': `템플릿`,
'se48bd9e6c2a3109d': `계정`,
'se58467472725ad0c': `이미지 해상도`,
'se58f06c2b0583ff7': `좌표 선택`,
'se5dc1e97fb743ade': `간격`,
'se619a501d1bfe6a5': `랩`,
'se62385ac082368d2': `선택 항목을 인용 출처로 표시합니다.`,
'se6297163cac9d276': `소스 편집`,
'se633223a0b88625e': `셀 배치`,
'se638417c560cfe5c': `내부 휴식`,
'se64f418b4e733b6c': `출력 삽입`,
'se79c0a3ac70d8fb3': `비율(X)`,
'se79fae3ac710dc36': `평균 비율(y)`,
'se7fad370d8fb4cec': `가독성 최적화`,
'se8a94b4effa2033e': `알파벳`,
'se95d4e55ea186d9a': `스크롤바 색상`,
'se96d43a515b8451c': `슬로베니아어`,
'se96fd76ba1b2975a': `중앙`,
'se9ac05f36b004eb0': `소개 둘러보기를 숨깁니다. 비활성화하면 둘러보기가 다시 표시됩니다.`,
'se9b1fec72ffd8f48': `로컬`,
'sea24bdcaa2bd2dec': `필수 스냅`,
'sea52df2b70a5c10d': `Ruby`,
'sea6e7291e27ec53f': `메타데이터 편집기를 토글합니다.`,
'sea896ed51ad33287': `사용 가능한 특정 스타일 없음`,
'seaaaeb09e3b4e78b': `편집 명령`,
'seabae79729c4b2ad': `이메일 전환`,
'seaecc8267bad6234': `중학교`,
'seaf97719986faf4f': `Gap`,
'seb19675a580f0628': `열 피하기`,
'seb4e52ef5ec7a7dc': `색상/효과`,
'seb8982ae8c3cdcc5': `인도네시아어`,
'sebbced89e0db2894': `첫 번째 기준선`,
'sec02109a0dd2a6c8': `강조 색상`,
'sec2557a35b702525': `변수`,
'sec2da4aa7a02b925': `아이슬란드어`,
'sec30fbb20f102670': `요약 삽입`,
'sec8b0b6c729816b6': `제목 그룹`,
'seccd05955adb76bc': `포스터`,
'sed17285cd25d6389': `package.json이 위치한 디렉터리`,
'sed318ec045c5144f': `Over`,
'sed713f1b916fb469': `테두리 간격(X)`,
'sed74a31b9172942c': `테두리 간격(y)`,
'sed86bd0deb2e5372': `텍스트 변환`,
'see2fcaedf9743ec6': `위치`,
'seec6798afe90ffc8': `인쇄`,
'sef00c258bc1ecf1e': `이 익스플로러에는 저장되지 않은 변경 사항이 있습니다.`,
'sef23dd271edd4a8b': `왼쪽 하단`,
'sef24caccbd4645ef': `플렉스 수축`,
'sef49aec68fd1dc66': `이름`,
'sef73fe18e351eb35': `키워드`,
'sef75f458d77491af': `옵션 그룹`,
'sefcf950b3cc4fc3b': `언어`,
'sf0c8e2b013e5ff18': `부타니`,
'sf0ca10f343249063': `콘텐츠`,
'sf0cab2483f66aa2e': `사용자 지정`,
'sf0e261e04eda82ff': `모양`,
'sf1045382c1fd9a85': `정확한 인쇄 색상`,
'sf14c35392ec7bf10': `Firefox에서는 이 기능을 사용할 수 없습니다. Chrome 또는 Edge에서 사용할 수 있습니다.`,
'sf14f9d5f9f6ca342': `더 가벼워짐`,
'sf1868dc19e3917bb': `스페인어`,
'sf190149f9d8bbb2a': `쓰기 모드`,
'sf1e79171c4856543': `확실하신가요? 이 작업은 되돌릴 수 없으며 모든 설정이 삭제되고 초기화됩니다.`,
'sf21c1f60c7515f44': `선택 항목을 샘플 출력으로 표시합니다.`,
'sf21fb4f4b9e8911f': `너비`,
'sf22a3737146ec910': `WebWriter는 문서에 SVG를 직접 삽입할 수 있습니다.`,
'sf2514d5dc78b1654': `위젯 삽입`,
'sf28903d4ca0ddcfc': `이 계정 삭제하기`,
'sf2ab37af0abc55ef': `인트로 투어 숨기기`,
'sf2bdb0b4d7b9c039': `벵골어`,
'sf2cbb5e519264e67': `가로 및 세로 크기 조정`,
'sf2d5cbc2fe0ad65a': `Sticky`,
'sf2d96d0eb32cb81f': `애니메이션 구성`,
'sf2de3dbe2108637a': `셰이프 렌더링`,
'sf2e08a945e9194d4': `Welch`,
'sf34696c526e810b4': `인라인`,
'sf39736a666dbb038': `트랙 삽입`,
'sf3c4da68b08a2590': `마다가스카르`,
'sf471ec2496f904cc': `변경 사항 삭제`,
'sf4849bc200e279ed': `표 캡션`,
'sf486ca1fdbe08645': `그림 삽입`,
'sf4b537d4cbd8f5fd': `텍스트 상단`,
'sf4e0e02a5277ef23': `텍스트 영역 삽입`,
'sf4f067d41efd4b83': `스케일(y)`,
'sf4f3cbd41f002b46': `스케일(x)`,
'sf4fa67d41f05a008': `스케일(z)`,
'sf5197db2d5f2926a': `회전`,
'sf52d840949a980d1': str`
          ${0} 은
          영구적으로 삭제됩니다. 확실하신가요? 
        `,
'sf55d634dcc743595': `서비스`,
'sf59c9081d106dd9c': `선택 항목을 변수로 표시합니다.`,
'sf5e76f774beb33c2': `이누크티튜트`,
'sf64a8229a8136552': `문서 삭제`,
'sf65df67a03bebe4b': `이 위젯에 필수`,
'sf6673729c03ae999': `웹라이터 재설정`,
'sf67571992e7dc88e': `만기`,
'sf6b4934598f7ed10': `선택 허용`,
'sf6e1665c7022a1f8': `비밀번호`,
'sf79e0d78b56444f1': `인라인 엔드`,
'sf7a5f7a7c80c3082': `둘 다`,
'sf7c0eba7c822e3d6': `Bold`,
'sf86bd4d2982f3b74': `선택 항목을 코드로 표시합니다.`,
'sf8e82313fa411494': `선택 항목을 링크로 표시`,
'sf955eff73fb6b573': `세르비아어`,
'sf9929e2d356260c5': `곱하기`,
'sf993bb199fefbe04': `모두`,
'sf9ecf969dd4b8164': `양쪽 가장자리`,
'sf9f2c719a04066ec': `앱`,
'sfa49a5bb1a5d353e': `비공개 액세스`,
'sfa59c7777e2a0eeb': `데이터 목록 삽입`,
'sfaa0a67db5c11f72': `첫 번째 텍스트 줄 들여쓰기`,
'sfb231a52211b133f': `텍스트 줄 바꿈 없음`,
'sfb68cae41d749423': `이니셜`,
'sfb9b6edb0ed378c9': `인용 출처`,
'sfbbab09dbe553571': `벡터 도면(SVG) 삽입`,
'sfc00292e778b67e2': `미터`,
'sfc63e31ac7c956ed': `선택`,
'sfc815c9078bba30a': `QR 코드를 이미지로 다운로드`,
'sfcdd8e672c75b713': `주소`,
'sfcebd18506f1e535': `흐름`,
'sfd0cde85070d2eb2': `Flex`,
'sfd77270c3f54f664': `출력`,
'sfdb1e4d90981a535': `이 문서 공유`,
'sfdeef3dccf409f81': `이 키워드는 위젯에 필요합니다.`,
'sfe6e758ad2603c1d': `석사`,
'sfee1c12daf838935': `컬러 화상`,
'sff303daee4dd9f7b': `Lingala`,
'sff3df0c2823ec6e4': `Verso`,
'sff99962304ac7d25': `대화 상자 삽입`,
'sffa395f64ec6ac36': `불가리아어`,
'sffdadf0a576fd802': `높이`,
'spaceKey': `공간`,
'tabKey': `⭾ 탭`,
'upKey': `↑ Up`,
's0dc07f97c821463c': `Comment selection`,
's780099588362f80f': `Definition item`,
's105540b7756c0232': `Definition term`,
's98b1cb8fb62909ec': `Group`,
's151349210ac1d2d8': `Insert a group`,
's2739460e44320108': `Chinese (Traditional)`,
'sdc12d4d35420eeb7': `Comments`,
's74540c1b595a229c': `TeX Formula`,
'sc221faca1ecb4aee': `Anonymous`,
's0b7ae9543c001867': `Reply`,
's52fb1524cb25d7ab': `New thread`,
'scbf29ce484222325': ``,
    };
  